// frontend/src/components/LanguageSelector.jsx
import React from 'react';
import { useLanguageStore } from '../store/useLanguageStore';
import { Globe } from 'lucide-react';

export const LanguageSelector = ({ hideIcon = false }) => {

  const { language, setLanguage } = useLanguageStore();

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  return (
    <div className="flex items-center gap-2 bg-white/50 backdrop-blur-sm border border-slate-200 p-1.5 rounded-xl shadow-sm hover:shadow-md transition-all">

      {/* <Globe className="w-3.5 h-3.5 text-blue-600" /> */}
      {!hideIcon && <Globe className="w-3.5 h-3.5 text-blue-600" />}
      <select
        value={language}
        onChange={handleLanguageChange}
        className="bg-transparent text-[10px] font-black text-slate-700 outline-none cursor-pointer uppercase tracking-tighter"
      >
        <option value="es">ES</option>
        <option value="en">EN</option>
        <option value="pt">PT</option>
      </select>
    </div>
  );
};